import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as atlas from 'azure-maps-control';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { SessionStorageService } from 'ngx-webstorage';
import { EcomNetworkUtils } from '../ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { EcomOlarDataService } from '../ecom-data-services/ecom-olar-data-service';
import { EComService } from '../ecom-services/ecom-common.service';
import { EcomCookies } from '../ecom-services/ecom-cookies';
import { EComGoogleAnalytics } from '../ecom-services/ecom-google-analytics';
import { EComWebStorage } from '../ecom-services/ecom-webstorage.services';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { EcomSettingService } from '../ecom-services/ecom-setting.service';
import { CompanySetting } from '../ecom-models/company-setting';
declare const google: any;
declare var chatWindowLoad: Function;

@Component({
  selector: 'app-ecom-stores',
  templateUrl: './ecom-stores.component.html',
  styleUrls: ['./ecom-stores.component.scss'],
  animations: [
    trigger('inOutAnimation', [
      state('in', style({ opacity: 1 })),
      transition(':enter', [style({ opacity: '0' }), animate('.5s ease-out', style({ opacity: '1' }))]),
      transition(':leave', [style({ opacity: '1' }), animate('.5s ease-out', style({ opacity: '0' }))]),
    ]),
  ],
})
export class EcomStoresComponent implements OnInit {
  // component class properties
  locationList = [];
  storageLocationList = [];
  dietaryVegetarian = false;
  dietaryVegan = false;
  dietaryGlutenFree = false;
  dietaryHalal = false;
  dietaryAllergyFriendly = false;
  modalRef: BsModalRef;
  config = {
    animated: true,
    class: 'modal-lg'
  };
  // class: 'modal-dialog-centered modal-lg'
  @ViewChild('locationmap', { static: true }) locationmap: ElementRef;
  map: any;
  public popup: atlas.Popup;
  public symbolLayer: atlas.layer.SymbolLayer;
  dataSource: atlas.source.DataSource;
  // initial center position for the map
  lat: number = 51.673858;
  lng: number = 7.815982;
  markers: marker[];
  locationAddress = '';
  companyName = '';
  locationLatLng = '';
  // google maps zoom level
  zoom: number = 15;
  mapAnimation = 'DROP';
  search_resturant_name = '';
  search_cusine = '';
  search_dietary = '';
  pageIndex = 0;
  searchretry = 0;
  lastCalledArraylength = 0;
  noRestaurants: boolean;
  restaurantFetch: boolean;
  defaultImage = './assets/images/storedefault.jpeg';
  defaultItemImage = './assets/images/Itemdefault.jpeg';
  filterArraySelectedData = [];

  // constructor to inject the class objects
  constructor(private eComGoogleAnalytics: EComGoogleAnalytics, public ecomOlarDataService: EcomOlarDataService, public router: Router, public ecomservice: EComService, private webstorage: EComWebStorage, private cookie: EcomCookies,
    private modalService: BsModalService, private networkUtils: EcomNetworkUtils,
    private sessionSt: SessionStorageService, { nativeElement }: ElementRef<HTMLImageElement>,
    private settingService: EcomSettingService) {
    this.noRestaurants = false;
    this.restaurantFetch = false;
    const supports = 'loading' in HTMLImageElement.prototype;
    if (supports) {
      nativeElement.setAttribute('loading', 'lazy');
    }
  }
  // component initialize and load the required data
  ngOnInit() {
    console.log('ngOnInit');
    let gTag = {
      'event': 'screen_view',
      'screen_name': 'stores'
    };
    this.eComGoogleAnalytics.customEvent(gTag);
    chatWindowLoad('none');
    if (!this.webstorage.sessionSt_is_session_valid) {
      this.router.navigate(['home']);
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    this.dietaryVegetarian = false;
    this.dietaryVegan = false;
    this.dietaryGlutenFree = false;
    this.dietaryHalal = false;
    this.dietaryAllergyFriendly = false;
    this.ecomservice.loadingPage.loading = true;

    let temp = this;
    setTimeout(function () {
      temp.LoadPage();
      temp.ecomOlarDataService.currentfiltersArraySelected.subscribe(list => {
        temp.filterArraySelectedData = list;
        temp.FilterStores();
      }
      );
    }, 0);

    // this.LoadPage();
    // this.ecomOlarDataService.currentfiltersArraySelected.subscribe(list => {
    //   this.filterArraySelectedData = list;
    //   this.FilterStores();
    // }
    // );
    this.ecomservice.loadingPage.loading = false;
  }

  LoadPage() {
    if (this.webstorage.sessionSt_locations_home) {
      this.webstorage.sessionSt_locations_home.forEach(element => {
        if (this.locationList.find(obj => { return obj.oocls_location_guid === element.oocls_location_guid }) === undefined) {
          this.locationList.push(element);
        }
      });
      if (!this.locationList.length) {
        this.noRestaurants = true;
      }
      this.locationList.sort((a, b) => a.location_distance_meters < b.location_distance_meters ? -1 : a.location_distance_meters > b.location_distance_meters ? 1 : 0);
      this.ecomservice.loadingPage.loading = false;
    } else {
      //if (this.webstorage.localSt_latlng) {
      if (this.cookie.cookie_latlng) {
        this.getSettingsOnScroll(true);
      } else {
        // load by default location of bukit bintang coordinates -- lat: 3.1467855, lng: 101.7113043
        //this.getSettingsOnScroll(true,true);
      }
    }
    // if (this.webstorage.localSt_latlng) {
    //   this.getSettingsOnScroll();
    // }
    this.sessionSt.observe('sessionst_reload')
      .subscribe((value) => this.getSettingsOnScroll(true));

  }

  onScrollDown() {
    // if (this.webstorage.sessionSt_locations_home
    //     && this.webstorage.sessionSt_home_page_index
    //     && this.webstorage.sessionSt_home_page_index === 0) {
    //     this.webstorage.sessionSt_locations_home.forEach(element => {
    //         if (this.locationList.find(obj => { return obj.oocls_location_guid === element.oocls_location_guid }) === undefined) {
    //             this.locationList.push(element);
    //         }
    //     });
    //     this.locationList.sort((a, b) => a.location_distance_meters < b.location_distance_meters ? -1 : a.location_distance_meters > b.location_distance_meters ? 1 : 0);
    //     this.ecomservice.loadingPage.loading = false;
    // } else {
    //     this.getSettingsOnScroll();
    // }
    //this.getSettingsOnScroll();
  }

  onScrollUp() {
  }


  getSettingsOnScroll(pageload = false, loadDefault = false) {
    // load by default location of Bukit Bintang, Kuala Lumpur, Federal Territory of Kuala Lumpur, Malaysia coordinates -- lat: 3.1467855, lng: 101.7113043
    if (this.pageIndex === 0) {
      this.locationList = [];
      this.storageLocationList = [];
      this.pageIndex = 1;
    }

    // this.pageIndex = this.pageIndex + 1;
    let input = {
      lat: 3.1467855,
      lng: 101.7113043,
      index: this.pageIndex,
      // companyOrLocation: this.search_resturant_name,
      // cuisine: this.search_cusine,
      // dietary: this.search_dietary
    };
    if (loadDefault) {
      input.lat = 3.1467855;
      input.lng = 101.7113043;
    } else {
      this.webstorage.sessionSt_home_page_index = this.pageIndex;
      //input.lat = this.webstorage.localSt_latlng.split(',')[0];
      //input.lng = this.webstorage.localSt_latlng.split(',')[1];
      input.lat = Number(this.cookie.cookie_latlng.split(',')[0]);
      input.lng = Number(this.cookie.cookie_latlng.split(',')[1]);
    }

    this.restaurantFetch = true;
    this.noRestaurants = false;
    this.ecomservice.httpPost(EcomNetworkUtils.POST_SETTINGS_BY_CORDINATES, input, '', false).subscribe((settings) => {
      this.restaurantFetch = false;
      if (settings['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (settings.status === 200) {
          const settingStores = settings.listValues;
          if (settingStores && settingStores !== '') {
            this.pageIndex = this.pageIndex + 1;
            this.ecomservice.loadingPage.loading = false;
            settingStores.forEach(element => {
              if (this.locationList.find(obj => { return obj.oocls_location_guid === element.oocls_location_guid }) === undefined) {

                this.locationList.push(element);
                this.storageLocationList.push(element);
              }
            });
            this.lastCalledArraylength = settingStores.length;

            // if (settingStores.length !== 0 && pageload === false) {
            //     this.searchLocationsAdd();
            // }

            this.webstorage.sessionSt_locations_home = this.storageLocationList;
            let locationPromos = [];
            for (let i = 0; i < this.locationList.length; i++) {
              if (locationPromos.length !== 15) {
                locationPromos.push(this.locationList[i]);
              }
            }
            this.webstorage.sessionSt_merchant_promos = locationPromos;
            this.searchLocations();
            // if (locationGoogleDistance.length > 0) {
            //     this.getDistanceFromGoogle(locationGoogleDistance);
            // }
          } else {
            this.noRestaurants = true;
          }
        } else {
          // network error
        }
      }
    });
  }

  getDistanceFromGoogle(locationList) {
    // set the distance from user location
    let destinationArray = []
    locationList.forEach(setting => {
      if (setting.oocls_location_latlang) {
        let lat = Number(setting.oocls_location_latlang.split(',')[0]);
        let lng = Number(setting.oocls_location_latlang.split(',')[1]);
        let dest = new google.maps.LatLng(lat, lng);
        destinationArray.push(dest);
      }
    });
    //const userCoOrdinates = this.webstorage.localSt_latlng;
    const userCoOrdinates = this.cookie.cookie_latlng;
    //if (this.webstorage.localSt_latlng) {
    if (this.cookie.cookie_latlng) {
      let service = new google.maps.DistanceMatrixService();
      var origincordinates = new google.maps.LatLng(Number(userCoOrdinates.split(',')[0]), Number(userCoOrdinates.split(',')[1]));
      service.getDistanceMatrix(
        {
          origins: [userCoOrdinates],
          destinations: destinationArray,
          unitSystem: google.maps.UnitSystem.METRIC,
          travelMode: google.maps.TravelMode['DRIVING'],
          //avoidHighways: false,
          //avoidTolls: false
        }, (response: any, status) => {
          if (status !== google.maps.DistanceMatrixStatus.OK || status !== 'OK') {
          } else {
            const trackingInput = {
              gat_ipaddress: this.webstorage.localSt_ip,
              gat_type: 'DISTANCE MATRIX API'
            };
            this.ecomservice.googleApiTrack(trackingInput);
            let distance = {
              text: '',
              value: ''
            }
            if (response.rows.length > 0) {
              if (this.pageIndex === 1) {
                response.rows[0].elements.forEach((mat, index) => {
                  if (mat.status === 'OK') {
                    distance = {
                      text: mat.distance.text,
                      value: mat.distance.value
                    }
                    if (this.locationList[index]) {
                      this.locationList[index].location_distance_meters = mat.distance.value;
                      this.locationList[index].location_distance = mat.distance.text;
                    }
                  } else {
                    if (this.locationList[index]) {
                      this.locationList[index].location_distance = '-';
                    }
                  }
                });
              } else {
                let rowIndex = (this.pageIndex - 1) * 25;
                response.rows[0].elements.forEach((mat, index) => {
                  if (mat.status === 'OK') {
                    distance = {
                      text: mat.distance.text,
                      value: mat.distance.value
                    }
                    if (this.locationList[rowIndex + index]) {
                      this.locationList[rowIndex + index].location_distance_meters = mat.distance.value;
                      this.locationList[rowIndex + index].location_distance = mat.distance.text;
                    }
                  } else {
                    if (this.locationList[rowIndex + index]) {
                      this.locationList[rowIndex + index].location_distance = '-';
                    }
                  }
                });
              }
            }
            this.locationList.sort((a, b) => a.location_distance_meters < b.location_distance_meters ? -1 : a.location_distance_meters > b.location_distance_meters ? 1 : 0);
            this.webstorage.sessionSt_locations_home = this.locationList;
            //                        this.searchLocationsAdd();
          }
        });
    }
  }


  // Method to display the dietary option
  showDietary(template) {
    this.modalRef = this.modalService.show(template, this.config);
  }

  // Method to close dietary dialog
  closeDietary() {
    this.modalRef.hide();
    //$('.modal').css({"display": "none"});
  }

  // Method to handle the dietary selected change
  selectDietary(type) {
    switch (type) {
      case 'VEGETARIAN':
        this.dietaryVegetarian = !this.dietaryVegetarian;
        break;
      case 'VEGAN':
        this.dietaryVegan = !this.dietaryVegan;
        break;
      case 'GLUTEN_FREE':
        this.dietaryGlutenFree = !this.dietaryGlutenFree;
        break;
      case 'HALAL':
        this.dietaryHalal = !this.dietaryHalal;
        break;
      case 'ALLERGY_FRIENDLY':
        this.dietaryAllergyFriendly = !this.dietaryAllergyFriendly;
        break;
    }
  }

  // Method to handle the locaiton click event
  onLocationClick(location) {
    this.webstorage.sessionSt_qr_paymentmode = undefined;
    this.webstorage.sessionSt_qr_code_scanned = undefined;
    this.webstorage.sessionSt_qrcode_type = undefined;
    this.webstorage.sessionSt_category_selected = undefined;
    this.webstorage.sessionSt_item_selected = undefined;
    this.webstorage.sessionSt_company_clicked = location.oocls_company_name.trim().replace(/\s+/g, '-').toLowerCase();
    this.webstorage.sessionSt_active_category = undefined;
    this.webstorage.sessionSt_searched_item = undefined;
    this.webstorage.sessionSt_store_open_for_orders = location.oocls_order_open ? 'YES' : 'NO';
    this.webstorage.sessionSt_scanned_dinein_table = false;
    this.webstorage.sessionSt_scanned_entry = false;
    this.webstorage.sessionSt_location_selected = location;
    this.webstorage.sessionSt_frompage = 'stores';
    //this.webstorage.sessionSt_topage = 'store';
    this.webstorage.sessionSt_topage = 'items';
    const setting = new CompanySetting({
      //serviceType: 'DINE_IN',
      oocls_location_pkid: location.oocls_location_pkid,
      oocls_company_id: location.oocls_company_id,
      oocls_company_pkid: location.oocls_company_pkid
    });
    this.settingService.setCompanySetting(setting);
    this.router.navigate(['items/m'], { queryParams: { L: location.oocls_location_pkid, C: location.oocls_company_pkid } });
  }



  // Method to handle the venue search event change
  onVenueSearch(value) {
    this.locationList = []
    const settingStores = this.webstorage.sessionSt_settings_locations;
    this.ecomservice.loadingPage.loading = false;
    if (settingStores && settingStores !== '') {
      this.ecomservice.loadingPage.loading = false;
      settingStores.forEach(element => {
        this.locationList.push(element);
      });
    }
    if (value && value.length > 0) {
      const searchlistbyCompany = this.locationList.filter(item => item.oocls_company_name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
      this.locationList = searchlistbyCompany;
    }
    // order by location distance descending
    const searchlistbydistance = this.locationList.sort((a, b) => a.location_distance_meters < b.location_distance_meters ? -1 : a.location_distance_meters > b.location_distance_meters ? 1 : 0);
    this.locationList = searchlistbydistance;
  }

  // Method to handle the cusine seach event
  onCusineSearch(value) {
    this.locationList = []
    const settingStores = this.webstorage.sessionSt_settings_locations;
    this.ecomservice.loadingPage.loading = false;
    if (settingStores && settingStores !== '') {
      this.ecomservice.loadingPage.loading = false;
      settingStores.forEach(element => {
        this.locationList.push(element);
      });
    }
    if (value && value.length > 0) {
      const searchlist = this.locationList.filter(item => item.oocls_cuisine.toLowerCase().indexOf(value.toLowerCase()) !== -1);
      this.locationList = searchlist;
    }
    // order by location distance descending
    const searchlistbydistance = this.locationList.sort((a, b) => a.location_distance_meters < b.location_distance_meters ? -1 : a.location_distance_meters > b.location_distance_meters ? 1 : 0);
    this.locationList = searchlistbydistance;
  }

  // Method to handle the option search event
  onOptionsSearch(value) {
    this.locationList = []
    const settingStores = this.webstorage.sessionSt_settings_locations;
    this.ecomservice.loadingPage.loading = false;
    if (settingStores && settingStores !== '') {
      this.ecomservice.loadingPage.loading = false;
      settingStores.forEach(element => {
        this.locationList.push(element);
      });
    }
    if (value && value.length > 0) {
      const searchlist = this.locationList.filter(item => item.oocls_dietary_options.toLowerCase().indexOf(value.toLowerCase()) !== -1);
      this.locationList = searchlist;
    }
    // order by location distance descending
    const searchlistbydistance = this.locationList.sort((a, b) => a.location_distance_meters < b.location_distance_meters ? -1 : a.location_distance_meters > b.location_distance_meters ? 1 : 0);
    this.locationList = searchlistbydistance;
  }



  headerEventEmitter(event) {
    let searchlist: any;
    let searchlistbydistance: any;
    let listTemp = this.locationList
    switch (event.type) {
      case 'cusine':
        this.search_cusine = event.data;
        this.searchLocations();
        //this.onCusineSearch(event.data);
        break;
      case 'option':
        this.search_dietary = event.data;
        this.searchLocations();
        //this.onOptionsSearch(event.data);
        break;
      case 'venue':
        this.search_resturant_name = event.data.trim();
        this.FilterStores();
        //this.searchLocations();
        //this.onVenueSearch(event.data);
        break;
      case 'userlocation':
        this.pageIndex = 0;
        this.getSettingsOnScroll();
        break;
      case 'locationchange':
        this.pageIndex = 0;
        this.headerEventEmitterStores(event);
        break;
      default:
        this.searchLocations();
        break;
    }
  }


  FilterStores() {
    let filters = this.filterArraySelectedData;
    this.searchretry = 1;
    this.locationList = [];
    this.ecomservice.loadingPage.loading = false;

    if (this.webstorage.sessionSt_locations_home) {
      this.locationList = this.webstorage.sessionSt_locations_home;
      // this.webstorage.sessionSt_locations_home.forEach(element => {
      //   if (this.locationList.find(obj => { return obj.oocls_location_guid === element.oocls_location_guid }) === undefined) {
      //     this.locationList.push(element);
      //   }
      // });
      // filter by searched name first
      let filterSelected = [];
      let filteredList = [];


      if (filters) {

        for (let i = 0; i < filters.length; i++) {
          if (filters[i].name === 'Dietary Options') {
            for (let j = 0; j < filters[i].values.length; j++) {
              if (filters[i].values[j].optionSelected) {
                filterSelected.push(filters[i].values[j]);
                const searchlist = this.locationList.filter(item => item.oocls_dietary_options.toLowerCase().indexOf(filters[i].values[j].dc_name.toLowerCase()) !== -1);
                searchlist.forEach(element => {
                  if (filteredList.find(obj => { return obj.oocls_location_guid === element.oocls_location_guid }) === undefined) {
                    filteredList.push(element);
                  }
                });
              }
            }
          }
          if (filters[i].name === 'Cuisine') {
            for (let j = 0; j < filters[i].values.length; j++) {
              if (filters[i].values[j].optionSelected) {
                filterSelected.push(filters[i].values[j]);
                const searchlist = this.locationList.filter(item => item.oocls_cuisine.toLowerCase().indexOf(filters[i].values[j].dc_name.toLowerCase()) !== -1);
                searchlist.forEach(element => {
                  if (filteredList.find(obj => { return obj.oocls_location_guid === element.oocls_location_guid }) === undefined) {
                    filteredList.push(element);
                  }
                });
              }
            }
          }
          if (filters[i].name === 'Dishes') {
            let locationDishes = [];
            for (let j = 0; j < filters[i].values.length; j++) {
              if (filters[i].values[j].optionSelected) {
                let locationListTemp = [];
                this.webstorage.sessionSt_locations_home.forEach(element => {
                  if (locationListTemp.find(obj => { return obj.oocls_location_guid === element.oocls_location_guid }) === undefined) {
                    locationListTemp.push(element);
                  }
                });
                const locationListForDish = locationListTemp;
                let namesearch = [];
                filterSelected.push(filters[i].values[j]);
                //search the matched dish for all locations                
                let optionname = filters[i].values[j].dc_name.toLowerCase();
                let optionNameArray = optionname.split(' ');
                let dishsearchCount = 0;
                let previousSearchName = '';
                optionNameArray.forEach(searchedname => {
                  if (dishsearchCount <= 1 && searchedname) {
                    let searchlist = [];
                    if (dishsearchCount == 0) {
                      let tempSearch = [];
                      searchlist = locationListForDish.filter(item => item.oocls_company_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                      searchlist.forEach(element => {
                        if (tempSearch.find(obj => { return obj.oocls_location_guid === element.oocls_location_guid }) === undefined) {
                          tempSearch.push(element);
                        }
                      });

                      //filter by item name
                      locationListForDish.forEach(location => {
                        if (location.list_location_items && location.list_location_items.length > 0) {
                          //item name search
                          const locationitemsearchlist = location.list_location_items.filter(i => i.oocip_item_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                          locationitemsearchlist.forEach(itemsearched => {
                            if (itemsearched.oocip_variant_name) {
                              itemsearched.item_name = itemsearched.oocip_item_name + ' - ' + itemsearched.oocip_variant_name;
                            } else {
                              itemsearched.item_name = itemsearched.oocip_item_name;
                            }
                            itemsearched.oocip_price_value = Number(itemsearched.oocip_price_value);
                            itemsearched.oocip_delivery_discount_price_value = Number(itemsearched.oocip_delivery_discount_price_value);
                            if (tempSearch.find(obj => { return obj.oocls_location_guid === itemsearched.oocip_location_guid }) === undefined) {
                              tempSearch.push(location);
                            }
                          });

                          // variant name search
                          const locationvariantearchlist = location.list_location_items.filter(i => i.oocip_variant_name !== null && i.oocip_variant_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                          locationvariantearchlist.forEach(itemsearched => {
                            if (itemsearched.oocip_variant_name) {
                              itemsearched.item_name = itemsearched.oocip_item_name + ' - ' + itemsearched.oocip_variant_name;
                            } else {
                              itemsearched.item_name = itemsearched.oocip_item_name;
                            }
                            itemsearched.oocip_price_value = Number(itemsearched.oocip_price_value);
                            itemsearched.oocip_delivery_discount_price_value = Number(itemsearched.oocip_delivery_discount_price_value);
                            if (tempSearch.find(obj => { return obj.oocls_location_guid === itemsearched.oocip_location_guid }) === undefined) {
                              tempSearch.push(location);
                            }
                          });

                          // add the searched item and variant to that location
                          let searchedItemVariantArray = [];
                          locationitemsearchlist.forEach(element => {
                            if (searchedItemVariantArray.find(obj => { return obj.oocip_guid === element.oocip_guid }) === undefined) {
                              searchedItemVariantArray.push(element);
                            }
                          });

                          locationvariantearchlist.forEach(element => {
                            if (searchedItemVariantArray.find(obj => { return obj.oocip_guid === element.oocip_guid }) === undefined) {
                              searchedItemVariantArray.push(element);
                            }
                          });
                          let locationTempIndex = -1;
                          let locationTempSearched = tempSearch.find((obj, index) => {
                            locationTempIndex = index;
                            return obj.oocls_location_guid === location.oocls_location_guid
                          });
                          if (locationTempSearched !== undefined) {
                            tempSearch[locationTempIndex].list_location_items = searchedItemVariantArray;
                          }
                        }
                      });
                      namesearch = tempSearch;
                    } else {
                      let tempSearch = [];
                      if (previousSearchName) {
                        let previousSearchArray = namesearch.filter(item => item.oocls_company_name.toLowerCase().search(previousSearchName.toLowerCase()) !== -1);
                        if (previousSearchArray) {
                          searchlist = previousSearchArray.filter(item => item.oocls_company_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                          searchlist.forEach(element => {
                            if (tempSearch.find(obj => { return obj.oocls_location_guid === element.oocls_location_guid }) === undefined) {
                              tempSearch.push(element);
                            }
                          });
                        }
                      } else {
                        searchlist = namesearch.filter(item => item.oocls_company_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                        searchlist.forEach(element => {
                          if (tempSearch.find(obj => { return obj.oocls_location_guid === element.oocls_location_guid }) === undefined) {
                            tempSearch.push(element);
                          }
                        });
                      }

                      //filter by item name
                      namesearch.forEach(location => {
                        if (location.list_location_items && location.list_location_items.length > 0) {
                          //item name search
                          let locationitemsearchlist = []
                          if (previousSearchName) {
                            let previousSearchArray = location.list_location_items.filter(i => i.oocip_item_name.toLowerCase().search(previousSearchName.toLowerCase()) !== -1);
                            if (previousSearchArray) {
                              locationitemsearchlist = previousSearchArray.filter(i => i.oocip_item_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                            }
                          }
                          locationitemsearchlist.forEach(itemsearched => {
                            if (itemsearched.oocip_variant_name) {
                              itemsearched.item_name = itemsearched.oocip_item_name + ' - ' + itemsearched.oocip_variant_name;
                            } else {
                              itemsearched.item_name = itemsearched.oocip_item_name;
                            }
                            itemsearched.oocip_price_value = Number(itemsearched.oocip_price_value);
                            itemsearched.oocip_delivery_discount_price_value = Number(itemsearched.oocip_delivery_discount_price_value);
                            if (tempSearch.find(obj => { return obj.oocls_location_guid === itemsearched.oocip_location_guid }) === undefined) {
                              tempSearch.push(location);
                            }
                          });
                          // variant name search
                          let locationvariantearchlist = [];
                          if (previousSearchName) {
                            let previousSearchArray = location.list_location_items.filter(i => i.oocip_variant_name !== null && i.oocip_variant_name.toLowerCase().search(previousSearchName.toLowerCase()) !== -1);
                            if (previousSearchArray) {
                              locationvariantearchlist = previousSearchArray.filter(i => i.oocip_variant_name !== null && i.oocip_variant_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                            }
                          }

                          //locationvariantearchlist = location.list_location_items.filter(i => i.oocip_variant_name !== null && i.oocip_variant_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                          locationvariantearchlist.forEach(itemsearched => {
                            if (itemsearched.oocip_variant_name) {
                              itemsearched.item_name = itemsearched.oocip_item_name + ' - ' + itemsearched.oocip_variant_name;
                            } else {
                              itemsearched.item_name = itemsearched.oocip_item_name;
                            }
                            itemsearched.oocip_price_value = Number(itemsearched.oocip_price_value);
                            itemsearched.oocip_delivery_discount_price_value = Number(itemsearched.oocip_delivery_discount_price_value);
                            if (tempSearch.find(obj => { return obj.oocls_location_guid === itemsearched.oocip_location_guid }) === undefined) {
                              tempSearch.push(location);
                            }
                          });

                          // add the searched item and variant to that location
                          let searchedItemVariantArray = [];
                          locationitemsearchlist.forEach(element => {
                            if (searchedItemVariantArray.find(obj => { return obj.oocip_guid === element.oocip_guid }) === undefined) {
                              searchedItemVariantArray.push(element);
                            }
                          });

                          locationvariantearchlist.forEach(element => {
                            if (searchedItemVariantArray.find(obj => { return obj.oocip_guid === element.oocip_guid }) === undefined) {
                              searchedItemVariantArray.push(element);
                            }
                          });
                          let locationTempIndex = -1;
                          let locationTempSearched = tempSearch.find((obj, index) => {
                            locationTempIndex = index;
                            return obj.oocls_location_guid === location.oocls_location_guid
                          });
                          let searched = {
                            location: location.oocls_location_guid,
                            items: searchedItemVariantArray
                          };
                          locationDishes.push(searched);
                          if (locationTempSearched !== undefined) {
                            tempSearch[locationTempIndex].list_location_items = searchedItemVariantArray;
                          }
                          /*
                          if (locationTempSearched !== undefined) {
                            if (tempSearch[locationTempIndex].list_location_items && tempSearch[locationTempIndex].list_location_items.length > 0) {
                              searchedItemVariantArray.forEach(sItem => {
                                let itemexist = tempSearch[locationTempIndex].list_location_items.find(item => {
                                  return item.oocip_guid === sItem.oocip_guid;
                                });
                                if (itemexist === undefined) {
                                  tempSearch[locationTempIndex].list_location_items.push(sItem);
                                }
                              });
                            } else {
                              tempSearch[locationTempIndex].list_location_items = searchedItemVariantArray;
                            }
                          }
                          */
                        }
                      });
                      namesearch = tempSearch;
                    }
                  }
                  previousSearchName = searchedname;
                  dishsearchCount = dishsearchCount + 1;
                });
                namesearch.forEach(element => {
                  let filterLocationIndex = -1;
                  let isExist = filteredList.find((obj, index) => {
                    filterLocationIndex = index;
                    return obj.oocls_location_guid === element.oocls_location_guid
                  });
                  if (isExist === undefined) {
                    filteredList.push(element);
                  } else {
                    element.list_location_items.forEach(item => {
                      // check if item exist before push
                      let itemExist = filteredList[filterLocationIndex].list_location_items.find(obj => {
                        return obj.oocip_guid === item.oocip_guid;
                      });
                      if (itemExist === undefined) {
                        filteredList[filterLocationIndex].list_location_items.push(item);
                      }
                    });
                  }
                });
              }
            }
          }
        }
      }

      let namesearch = [];
      let searchcount = 0;
      if (this.search_resturant_name) {
        let searchnamearray = this.search_resturant_name.split(' ');
        let previousSearchName = '';
        searchnamearray.forEach(searchedname => {
          if (searchcount <= 1 && searchedname) {
            // filter the matching resturant name
            if (filterSelected.length > 0) {
              /*
              const searchlist = filteredList.filter(item => item.oocls_company_name.toLowerCase().search(this.search_resturant_name.toLowerCase()) !== -1);
              //filteredList = [];
              searchlist.forEach(element => {
                if (namesearch.find(obj => { return obj.oocls_location_guid === element.oocls_location_guid }) === undefined) {
                  namesearch.push(element);
                }
              });

              //filter by item name
              filteredList.forEach(location => {
                if (location.list_location_items && location.list_location_items.length > 0) {
                  //item name search
                  const locationitemsearchlist = location.list_location_items.filter(i => i.oocip_item_name.toLowerCase().search(this.search_resturant_name.toLowerCase()) !== -1);
                  locationitemsearchlist.forEach(itemsearched => {
                    if (itemsearched.oocip_variant_name) {
                      itemsearched.item_name = itemsearched.oocip_item_name + ' - ' + itemsearched.oocip_variant_name;
                    } else {
                      itemsearched.item_name = itemsearched.oocip_item_name;
                    }
                    itemsearched.oocip_price_value = Number(itemsearched.oocip_price_value);
                    itemsearched.oocip_delivery_discount_price_value = Number(itemsearched.oocip_delivery_discount_price_value);
                    if (namesearch.find(obj => { return obj.oocls_location_guid === itemsearched.oocip_location_guid }) === undefined) {
                      namesearch.push(location);
                    }
                  });

                  // variant name search
                  const locationvariantearchlist = location.list_location_items.filter(i => i.oocip_variant_name !== null && i.oocip_variant_name.toLowerCase().search(this.search_resturant_name.toLowerCase()) !== -1);
                  locationvariantearchlist.forEach(itemsearched => {
                    if (itemsearched.oocip_variant_name) {
                      itemsearched.item_name = itemsearched.oocip_item_name + ' - ' + itemsearched.oocip_variant_name;
                    } else {
                      itemsearched.item_name = itemsearched.oocip_item_name;
                    }
                    itemsearched.oocip_price_value = Number(itemsearched.oocip_price_value);
                    itemsearched.oocip_delivery_discount_price_value = Number(itemsearched.oocip_delivery_discount_price_value);
                    if (namesearch.find(obj => { return obj.oocls_location_guid === itemsearched.oocip_location_guid }) === undefined) {
                      namesearch.push(location);
                    }
                  });
                }
              });
              */
              let searchlist = [];
              if (searchcount == 0) {
                let tempSearch = [];
                searchlist = filteredList.filter(item => item.oocls_company_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                searchlist.forEach(element => {
                  if (tempSearch.find(obj => { return obj.oocls_location_guid === element.oocls_location_guid }) === undefined) {
                    tempSearch.push(element);
                  }
                });

                //filter by item name
                filteredList.forEach(location => {
                  if (location.list_location_items && location.list_location_items.length > 0) {
                    //item name search
                    const locationitemsearchlist = location.list_location_items.filter(i => i.oocip_item_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                    locationitemsearchlist.forEach(itemsearched => {
                      if (itemsearched.oocip_variant_name) {
                        itemsearched.item_name = itemsearched.oocip_item_name + ' - ' + itemsearched.oocip_variant_name;
                      } else {
                        itemsearched.item_name = itemsearched.oocip_item_name;
                      }
                      itemsearched.oocip_price_value = Number(itemsearched.oocip_price_value);
                      itemsearched.oocip_delivery_discount_price_value = Number(itemsearched.oocip_delivery_discount_price_value);
                      if (tempSearch.find(obj => { return obj.oocls_location_guid === itemsearched.oocip_location_guid }) === undefined) {
                        tempSearch.push(location);
                      }
                    });

                    // variant name search
                    const locationvariantearchlist = location.list_location_items.filter(i => i.oocip_variant_name !== null && i.oocip_variant_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                    locationvariantearchlist.forEach(itemsearched => {
                      if (itemsearched.oocip_variant_name) {
                        itemsearched.item_name = itemsearched.oocip_item_name + ' - ' + itemsearched.oocip_variant_name;
                      } else {
                        itemsearched.item_name = itemsearched.oocip_item_name;
                      }
                      itemsearched.oocip_price_value = Number(itemsearched.oocip_price_value);
                      itemsearched.oocip_delivery_discount_price_value = Number(itemsearched.oocip_delivery_discount_price_value);
                      if (tempSearch.find(obj => { return obj.oocls_location_guid === itemsearched.oocip_location_guid }) === undefined) {
                        tempSearch.push(location);
                      }
                    });

                    // add the searched item and variant to that location
                    let searchedItemVariantArray = [];
                    locationitemsearchlist.forEach(element => {
                      if (searchedItemVariantArray.find(obj => { return obj.oocip_guid === element.oocip_guid }) === undefined) {
                        searchedItemVariantArray.push(element);
                      }
                    });

                    locationvariantearchlist.forEach(element => {
                      if (searchedItemVariantArray.find(obj => { return obj.oocip_guid === element.oocip_guid }) === undefined) {
                        searchedItemVariantArray.push(element);
                      }
                    });
                    let locationTempIndex = -1;
                    let locationTempSearched = tempSearch.find((obj, index) => {
                      locationTempIndex = index;
                      return obj.oocls_location_guid === location.oocls_location_guid
                    });
                    if (locationTempSearched !== undefined) {
                      tempSearch[locationTempIndex].list_location_items = searchedItemVariantArray;
                    }

                  }
                });
                namesearch = tempSearch;
              } else {
                let tempSearch = [];

                searchlist = namesearch.filter(item => item.oocls_company_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                searchlist.forEach(element => {
                  if (tempSearch.find(obj => { return obj.oocls_location_guid === element.oocls_location_guid }) === undefined) {
                    tempSearch.push(element);
                  }
                });

                //filter by item name
                namesearch.forEach(location => {
                  if (location.list_location_items && location.list_location_items.length > 0) {
                    //item name search
                    let locationitemsearchlist = []
                    if (previousSearchName) {
                      let previousSearchArray = location.list_location_items.filter(i => i.oocip_item_name.toLowerCase().search(previousSearchName.toLowerCase()) !== -1);
                      if (previousSearchArray) {
                        locationitemsearchlist = previousSearchArray.filter(i => i.oocip_item_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                      }
                    }
                    locationitemsearchlist.forEach(itemsearched => {
                      if (itemsearched.oocip_variant_name) {
                        itemsearched.item_name = itemsearched.oocip_item_name + ' - ' + itemsearched.oocip_variant_name;
                      } else {
                        itemsearched.item_name = itemsearched.oocip_item_name;
                      }
                      itemsearched.oocip_price_value = Number(itemsearched.oocip_price_value);
                      itemsearched.oocip_delivery_discount_price_value = Number(itemsearched.oocip_delivery_discount_price_value);
                      if (tempSearch.find(obj => { return obj.oocls_location_guid === itemsearched.oocip_location_guid }) === undefined) {
                        tempSearch.push(location);
                      }
                    });

                    // variant name search
                    let locationvariantearchlist = [];
                    if (previousSearchName) {
                      let previousSearchArray = location.list_location_items.filter(i => i.oocip_variant_name !== null && i.oocip_variant_name.toLowerCase().search(previousSearchName.toLowerCase()) !== -1);
                      if (previousSearchArray) {
                        locationvariantearchlist = previousSearchArray.filter(i => i.oocip_variant_name !== null && i.oocip_variant_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                      }
                    }
                    //locationvariantearchlist = location.list_location_items.filter(i => i.oocip_variant_name !== null && i.oocip_variant_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                    locationvariantearchlist.forEach(itemsearched => {
                      if (itemsearched.oocip_variant_name) {
                        itemsearched.item_name = itemsearched.oocip_item_name + ' - ' + itemsearched.oocip_variant_name;
                      } else {
                        itemsearched.item_name = itemsearched.oocip_item_name;
                      }
                      itemsearched.oocip_price_value = Number(itemsearched.oocip_price_value);
                      itemsearched.oocip_delivery_discount_price_value = Number(itemsearched.oocip_delivery_discount_price_value);
                      if (tempSearch.find(obj => { return obj.oocls_location_guid === itemsearched.oocip_location_guid }) === undefined) {
                        tempSearch.push(location);
                      }
                    });

                    // add the searched item and variant to that location
                    let searchedItemVariantArray = [];
                    locationitemsearchlist.forEach(element => {
                      if (searchedItemVariantArray.find(obj => { return obj.oocip_guid === element.oocip_guid }) === undefined) {
                        searchedItemVariantArray.push(element);
                      }
                    });

                    locationvariantearchlist.forEach(element => {
                      if (searchedItemVariantArray.find(obj => { return obj.oocip_guid === element.oocip_guid }) === undefined) {
                        searchedItemVariantArray.push(element);
                      }
                    });
                    let locationTempIndex = -1;
                    let locationTempSearched = tempSearch.find((obj, index) => {
                      locationTempIndex = index;
                      return obj.oocls_location_guid === location.oocls_location_guid
                    });
                    if (locationTempSearched !== undefined) {
                      tempSearch[locationTempIndex].list_location_items = searchedItemVariantArray;
                    }
                  }
                });
                namesearch = tempSearch;
              }
            } else {
              let searchlist = [];
              if (searchcount == 0) {
                let tempSearch = [];

                searchlist = this.locationList.filter(item => item.oocls_company_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                searchlist.forEach(element => {
                  if (tempSearch.find(obj => { return obj.oocls_location_guid === element.oocls_location_guid }) === undefined) {
                    tempSearch.push(element);
                  }
                });

                //filter by item name
                this.locationList.forEach(location => {
                  if (location.list_location_items && location.list_location_items.length > 0) {
                    //item name search
                    const locationitemsearchlist = location.list_location_items.filter(i => i.oocip_item_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                    locationitemsearchlist.forEach(itemsearched => {
                      if (itemsearched.oocip_variant_name) {
                        itemsearched.item_name = itemsearched.oocip_item_name + ' - ' + itemsearched.oocip_variant_name;
                      } else {
                        itemsearched.item_name = itemsearched.oocip_item_name;
                      }
                      itemsearched.oocip_price_value = Number(itemsearched.oocip_price_value);
                      itemsearched.oocip_delivery_discount_price_value = Number(itemsearched.oocip_delivery_discount_price_value);
                      if (tempSearch.find(obj => { return obj.oocls_location_guid === itemsearched.oocip_location_guid }) === undefined) {
                        tempSearch.push(location);
                      }
                    });

                    // variant name search
                    const locationvariantearchlist = location.list_location_items.filter(i => i.oocip_variant_name !== null && i.oocip_variant_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                    locationvariantearchlist.forEach(itemsearched => {
                      if (itemsearched.oocip_variant_name) {
                        itemsearched.item_name = itemsearched.oocip_item_name + ' - ' + itemsearched.oocip_variant_name;
                      } else {
                        itemsearched.item_name = itemsearched.oocip_item_name;
                      }
                      itemsearched.oocip_price_value = Number(itemsearched.oocip_price_value);
                      itemsearched.oocip_delivery_discount_price_value = Number(itemsearched.oocip_delivery_discount_price_value);
                      if (tempSearch.find(obj => { return obj.oocls_location_guid === itemsearched.oocip_location_guid }) === undefined) {
                        tempSearch.push(location);
                      }
                    });


                    // add the searched item and variant to that location
                    let searchedItemVariantArray = [];
                    locationitemsearchlist.forEach(element => {
                      if (searchedItemVariantArray.find(obj => { return obj.oocip_guid === element.oocip_guid }) === undefined) {
                        searchedItemVariantArray.push(element);
                      }
                    });

                    locationvariantearchlist.forEach(element => {
                      if (searchedItemVariantArray.find(obj => { return obj.oocip_guid === element.oocip_guid }) === undefined) {
                        searchedItemVariantArray.push(element);
                      }
                    });
                    let locationTempIndex = -1;
                    let locationTempSearched = tempSearch.find((obj, index) => {
                      locationTempIndex = index;
                      return obj.oocls_location_guid === location.oocls_location_guid
                    });
                    if (locationTempSearched !== undefined) {
                      tempSearch[locationTempIndex].list_location_items = searchedItemVariantArray;
                    }
                  }
                });
                namesearch = tempSearch;
              } else {
                let tempSearch = [];

                searchlist = namesearch.filter(item => item.oocls_company_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                searchlist.forEach(element => {
                  if (tempSearch.find(obj => { return obj.oocls_location_guid === element.oocls_location_guid }) === undefined) {
                    tempSearch.push(element);
                  }
                });

                //filter by item name
                namesearch.forEach(location => {
                  if (location.list_location_items && location.list_location_items.length > 0) {
                    //item name search
                    let locationitemsearchlist = []
                    if (previousSearchName) {
                      let previousSearchArray = location.list_location_items.filter(i => i.oocip_item_name.toLowerCase().search(previousSearchName.toLowerCase()) !== -1);
                      if (previousSearchArray) {
                        locationitemsearchlist = previousSearchArray.filter(i => i.oocip_item_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                      }
                    }
                    locationitemsearchlist.forEach(itemsearched => {
                      if (itemsearched.oocip_variant_name) {
                        itemsearched.item_name = itemsearched.oocip_item_name + ' - ' + itemsearched.oocip_variant_name;
                      } else {
                        itemsearched.item_name = itemsearched.oocip_item_name;
                      }
                      itemsearched.oocip_price_value = Number(itemsearched.oocip_price_value);
                      itemsearched.oocip_delivery_discount_price_value = Number(itemsearched.oocip_delivery_discount_price_value);
                      if (tempSearch.find(obj => { return obj.oocls_location_guid === itemsearched.oocip_location_guid }) === undefined) {
                        tempSearch.push(location);
                      }
                    });

                    // variant name search
                    let locationvariantearchlist = [];
                    if (previousSearchName) {
                      let previousSearchArray = location.list_location_items.filter(i => i.oocip_variant_name !== null && i.oocip_variant_name.toLowerCase().search(previousSearchName.toLowerCase()) !== -1);
                      if (previousSearchArray) {
                        locationvariantearchlist = previousSearchArray.filter(i => i.oocip_variant_name !== null && i.oocip_variant_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                      }
                    }
                    //locationvariantearchlist = location.list_location_items.filter(i => i.oocip_variant_name !== null && i.oocip_variant_name.toLowerCase().search(searchedname.toLowerCase()) !== -1);
                    locationvariantearchlist.forEach(itemsearched => {
                      if (itemsearched.oocip_variant_name) {
                        itemsearched.item_name = itemsearched.oocip_item_name + ' - ' + itemsearched.oocip_variant_name;
                      } else {
                        itemsearched.item_name = itemsearched.oocip_item_name;
                      }
                      itemsearched.oocip_price_value = Number(itemsearched.oocip_price_value);
                      itemsearched.oocip_delivery_discount_price_value = Number(itemsearched.oocip_delivery_discount_price_value);
                      if (tempSearch.find(obj => { return obj.oocls_location_guid === itemsearched.oocip_location_guid }) === undefined) {
                        tempSearch.push(location);
                      }
                    });

                    // add the searched item and variant to that location
                    let searchedItemVariantArray = [];
                    locationitemsearchlist.forEach(element => {
                      if (searchedItemVariantArray.find(obj => { return obj.oocip_guid === element.oocip_guid }) === undefined) {
                        searchedItemVariantArray.push(element);
                      }
                    });

                    locationvariantearchlist.forEach(element => {
                      if (searchedItemVariantArray.find(obj => { return obj.oocip_guid === element.oocip_guid }) === undefined) {
                        searchedItemVariantArray.push(element);
                      }
                    });
                    let locationTempIndex = -1;
                    let locationTempSearched = tempSearch.find((obj, index) => {
                      locationTempIndex = index;
                      return obj.oocls_location_guid === location.oocls_location_guid
                    });
                    if (locationTempSearched !== undefined) {
                      tempSearch[locationTempIndex].list_location_items = searchedItemVariantArray;
                    }

                  }
                });
                namesearch = tempSearch;
              }

            }
            previousSearchName = searchedname;
            searchcount = searchcount + 1;
          }
        });
      }
      if (namesearch.length > 0 || this.search_resturant_name.length > 0) {
        this.locationList = namesearch;
      } else {
        if (filterSelected.length > 0) {
          this.locationList = filteredList;
        } else {
          // name search list
          if (filteredList.length > 0) {
            this.locationList = filteredList;
          }
        }
      }


      // order by location distance descending
      const searchlistbydistance = this.locationList.sort((a, b) => a.location_distance_meters < b.location_distance_meters ? -1 : a.location_distance_meters > b.location_distance_meters ? 1 : 0);
      this.locationList = searchlistbydistance;
      if (this.locationList.length === 0) {
        this.noRestaurants = true;
      } else {
        this.noRestaurants = false;
      }
    }
  }

  /*
  headerEventEmitter(event) {
    switch (event.type) {
      case 'cusine':
        this.search_cusine = event.data;
        break;
      case 'option':
        this.search_dietary = event.data;
        break;
      case 'venue':
        this.search_resturant_name = event.data;
        break;
    }
    //this.getSettingsOnScroll();
    this.searchLocations();
  }
  */

  // searchLocationsAdd() {
  //     this.searchretry = this.searchretry + 1;
  //     this.ecomservice.loadingPage.loading = true;
  //     if (this.webstorage.sessionSt_locations_home) {
  //         let search_condition_matched = false;
  //         if (this.search_resturant_name && this.search_cusine && this.search_dietary) {
  //             search_condition_matched = true;
  //            // let searchlist = this.locationList.sort((a, b) => a.oocls_cuisine.toLowerCase() < b.oocls_cuisine.toLowerCase() ? -1 : a.oocls_cuisine.toLowerCase() > b.oocls_cuisine.toLowerCase() ? 1 : 0);
  //             const searchlist = this.locationList.filter(item => item.oocls_company_name.toLowerCase().indexOf(this.search_resturant_name.toLowerCase()) !== -1
  //               && item.oocls_cuisine.toLowerCase().indexOf(this.search_cusine.toLowerCase()) !== -1
  //               && item.oocls_dietary_options.toLowerCase().indexOf(this.search_dietary.toLowerCase()) !== -1);
  //             // searchlist = searchlist.filter(item => item.oocls_company_name.toLowerCase().indexOf(this.search_resturant_name.toLowerCase()) !== -1
  //             //     && item.oocls_dietary_options.toLowerCase().indexOf(this.search_dietary.toLowerCase()) !== -1);
  //             this.locationList = searchlist;
  //         }
  //         else if (!search_condition_matched && this.search_resturant_name && this.search_cusine) {
  //             search_condition_matched = true;
  //            // let searchlist = this.locationList.sort((a, b) => a.oocls_cuisine.toLowerCase() < b.oocls_cuisine.toLowerCase() ? -1 : a.oocls_cuisine.toLowerCase() > b.oocls_cuisine.toLowerCase() ? 1 : 0);
  //             const searchlist = this.locationList.filter(item => item.oocls_company_name.toLowerCase().indexOf(this.search_resturant_name.toLowerCase()) !== -1
  //               && item.oocls_cuisine.toLowerCase().indexOf(this.search_cusine.toLowerCase()) !== -1);
  //            // searchlist = searchlist.filter(item => item.oocls_company_name.toLowerCase().indexOf(this.search_resturant_name.toLowerCase()) !== -1);
  //             this.locationList = searchlist;
  //         }
  //         else if (!search_condition_matched && this.search_resturant_name && this.search_dietary) {
  //             search_condition_matched = true;
  //             const searchlist = this.locationList.filter(item => item.oocls_company_name.toLowerCase().indexOf(this.search_resturant_name.toLowerCase()) !== -1
  //                 && item.oocls_dietary_options.toLowerCase().indexOf(this.search_dietary.toLowerCase()) !== -1);
  //             this.locationList = searchlist;
  //         }
  //         else if (!search_condition_matched && this.search_dietary && this.search_cusine) {
  //             search_condition_matched = true;
  //            // let searchlist = this.locationList.sort((a, b) => a.oocls_cuisine.toLowerCase() < b.oocls_cuisine.toLowerCase() ? -1 : a.oocls_cuisine.toLowerCase() > b.oocls_cuisine.toLowerCase() ? 1 : 0);
  //             const searchlist = this.locationList.filter(item => item.oocls_cuisine.toLowerCase().indexOf(this.search_cusine.toLowerCase()) !== -1
  //               && item.oocls_dietary_options.toLowerCase().indexOf(this.search_dietary.toLowerCase()) !== -1);
  //             // searchlist = searchlist.filter(item => item.oocls_dietary_options.toLowerCase().indexOf(this.search_dietary.toLowerCase()) !== -1);
  //             this.locationList = searchlist;
  //         }
  //         else if (!search_condition_matched && this.search_cusine) {
  //             search_condition_matched = true;
  //             const searchlist = this.locationList.filter(item => item.oocls_cuisine.toLowerCase().indexOf(this.search_cusine.toLowerCase()) !== -1);
  //            // const searchlist = this.locationList.sort((a, b) => a.oocls_cuisine.toLowerCase() < b.oocls_cuisine.toLowerCase() ? -1 : a.oocls_cuisine.toLowerCase() > b.oocls_cuisine.toLowerCase() ? 1 : 0);
  //             this.locationList = searchlist;
  //         }
  //         else if (!search_condition_matched && this.search_dietary) {
  //             search_condition_matched = true;
  //             const searchlist = this.locationList.filter(item => item.oocls_dietary_options.toLowerCase().indexOf(this.search_dietary.toLowerCase()) !== -1);
  //             this.locationList = searchlist;
  //         }
  //         else if (!search_condition_matched && this.search_resturant_name) {
  //             search_condition_matched = true;
  //             const searchlist = this.locationList.filter(item => item.oocls_company_name.toLowerCase().indexOf(this.search_resturant_name.toLowerCase()) !== -1);
  //             this.locationList = searchlist;
  //         }
  //         // order by location distance descending
  //         const searchlistbydistance = this.locationList.sort((a, b) => a.location_distance_meters < b.location_distance_meters ? -1 : a.location_distance_meters > b.location_distance_meters ? 1 : 0);
  //         this.locationList = searchlistbydistance;
  //     }
  //     if (this.searchretry < 3 && this.locationList.length < 25) {
  //         this.getSettingsOnScroll();
  //     }
  // }

  searchLocations() {
    this.searchretry = 1;
    this.locationList = [];
    this.ecomservice.loadingPage.loading = false;

    if (this.webstorage.sessionSt_locations_home) {
      //this.locationList = this.webstorage.sessionSt_locations_home;
      this.webstorage.sessionSt_locations_home.forEach(element => {
        if (this.locationList.find(obj => { return obj.oocls_location_guid === element.oocls_location_guid }) === undefined) {
          this.locationList.push(element);
        }
      });
      let search_condition_matched = false;
      if (this.search_resturant_name && this.search_cusine && this.search_dietary) {
        search_condition_matched = true;
        //  let searchlist = this.locationList.sort((a, b) => a.oocls_cuisine.toLowerCase() < b.oocls_cuisine.toLowerCase() ? -1 : a.oocls_cuisine.toLowerCase() > b.oocls_cuisine.toLowerCase() ? 1 : 0);
        const searchlist = this.locationList.filter(item => item.oocls_company_name.toLowerCase().indexOf(this.search_resturant_name.toLowerCase()) !== -1
          && item.oocls_cuisine.toLowerCase().indexOf(this.search_cusine.toLowerCase()) !== -1
          && item.oocls_dietary_options.toLowerCase().indexOf(this.search_dietary.toLowerCase()) !== -1);
        // searchlist = searchlist.filter(item => item.oocls_company_name.toLowerCase().indexOf(this.search_resturant_name.toLowerCase()) !== -1
        //     && item.oocls_dietary_options.toLowerCase().indexOf(this.search_dietary.toLowerCase()) !== -1);
        this.locationList = searchlist;
      } else if (!search_condition_matched && this.search_resturant_name && this.search_cusine) {
        search_condition_matched = true;
        // let searchlist = this.locationList.sort((a, b) => a.oocls_cuisine.toLowerCase() < b.oocls_cuisine.toLowerCase() ? -1 : a.oocls_cuisine.toLowerCase() > b.oocls_cuisine.toLowerCase() ? 1 : 0);
        const searchlist = this.locationList.filter(item => item.oocls_company_name.toLowerCase().indexOf(this.search_resturant_name.toLowerCase()) !== -1
          && item.oocls_cuisine.toLowerCase().indexOf(this.search_cusine.toLowerCase()) !== -1);
        // searchlist = searchlist.filter(item => item.oocls_company_name.toLowerCase().indexOf(this.search_resturant_name.toLowerCase()) !== -1);
        this.locationList = searchlist;
      } else if (!search_condition_matched && this.search_resturant_name && this.search_dietary) {
        search_condition_matched = true;
        const searchlist = this.locationList.filter(item => item.oocls_company_name.toLowerCase().indexOf(this.search_resturant_name.toLowerCase()) !== -1
          && item.oocls_dietary_options.toLowerCase().indexOf(this.search_dietary.toLowerCase()) !== -1);
        this.locationList = searchlist;
      } else if (!search_condition_matched && this.search_dietary && this.search_cusine) {
        search_condition_matched = true;
        // let searchlist = this.locationList.sort((a, b) => a.oocls_cuisine.toLowerCase() < b.oocls_cuisine.toLowerCase() ? -1 : a.oocls_cuisine.toLowerCase() > b.oocls_cuisine.toLowerCase() ? 1 : 0);
        const searchlist = this.locationList.filter(item => item.oocls_cuisine.toLowerCase().indexOf(this.search_cusine.toLowerCase()) !== -1
          && item.oocls_dietary_options.toLowerCase().indexOf(this.search_dietary.toLowerCase()) !== -1);
        //  searchlist = searchlist.filter(item => item.oocls_dietary_options.toLowerCase().indexOf(this.search_dietary.toLowerCase()) !== -1);
        this.locationList = searchlist;
      } else if (!search_condition_matched && this.search_cusine) {
        search_condition_matched = true;
        const searchlist = this.locationList.filter(item => item.oocls_cuisine.toLowerCase().indexOf(this.search_cusine.toLowerCase()) !== -1);
        // const searchlist = this.locationList.sort((a, b) => a.oocls_cuisine.toLowerCase() < b.oocls_cuisine.toLowerCase() ? -1 : a.oocls_cuisine.toLowerCase() > b.oocls_cuisine.toLowerCase() ? 1 : 0);
        this.locationList = searchlist;
      } else if (!search_condition_matched && this.search_dietary) {
        search_condition_matched = true;
        const searchlist = this.locationList.filter(item => item.oocls_dietary_options.toLowerCase().indexOf(this.search_dietary.toLowerCase()) !== -1);
        this.locationList = searchlist;
      } else if (!search_condition_matched && this.search_resturant_name) {
        search_condition_matched = true;
        const searchlist = this.locationList.filter(item => item.oocls_company_name.toLowerCase().indexOf(this.search_resturant_name.toLowerCase()) !== -1);
        this.locationList = searchlist;
      }
      // order by location distance descending
      const searchlistbydistance = this.locationList.sort((a, b) => a.location_distance_meters < b.location_distance_meters ? -1 : a.location_distance_meters > b.location_distance_meters ? 1 : 0);
      this.locationList = searchlistbydistance;
      if (this.locationList.length === 0) {
        this.noRestaurants = true;
      } else {
        this.noRestaurants = false;
      }
    }
  }

  getSearchedList() {
    this.locationList = [];
    const settingStores = this.webstorage.sessionSt_settings_locations;
    this.ecomservice.loadingPage.loading = false;
    if (settingStores && settingStores !== '') {
      this.ecomservice.loadingPage.loading = false;
      settingStores.forEach(element => {
        this.locationList.push(element);
      });
    }
    let search_condition_matched = false;
    if (this.search_resturant_name && this.search_cusine && this.search_dietary) {
      search_condition_matched = true;
      const searchlist = this.locationList.filter(item => item.oocls_company_name.toLowerCase().indexOf(this.search_resturant_name.toLowerCase()) !== -1
        && item.oocls_cuisine.toLowerCase().indexOf(this.search_cusine.toLowerCase()) !== -1
        && item.oocls_dietary_options.toLowerCase().indexOf(this.search_dietary.toLowerCase()) !== -1);
      this.locationList = searchlist;
    }
    else if (!search_condition_matched && this.search_resturant_name && this.search_cusine) {
      search_condition_matched = true;
      const searchlist = this.locationList.filter(item => item.oocls_company_name.toLowerCase().indexOf(this.search_resturant_name.toLowerCase()) !== -1
        && item.oocls_cuisine.toLowerCase().indexOf(this.search_cusine.toLowerCase()) !== -1);
      this.locationList = searchlist;
    }
    else if (!search_condition_matched && this.search_resturant_name && this.search_dietary) {
      search_condition_matched = true;
      const searchlist = this.locationList.filter(item => item.oocls_company_name.toLowerCase().indexOf(this.search_resturant_name.toLowerCase()) !== -1
        && item.oocls_dietary_options.toLowerCase().indexOf(this.search_dietary.toLowerCase()) !== -1);
      this.locationList = searchlist;
    }
    else if (!search_condition_matched && this.search_dietary && this.search_cusine) {
      search_condition_matched = true;
      const searchlist = this.locationList.filter(item => item.oocls_cuisine.toLowerCase().indexOf(this.search_cusine.toLowerCase()) !== -1
        && item.oocls_dietary_options.toLowerCase().indexOf(this.search_dietary.toLowerCase()) !== -1);
      this.locationList = searchlist;
    }
    else if (!search_condition_matched && this.search_cusine) {
      search_condition_matched = true;
      const searchlist = this.locationList.filter(item => item.oocls_cuisine.toLowerCase().indexOf(this.search_cusine.toLowerCase()) !== -1);
      this.locationList = searchlist;
    }
    else if (!search_condition_matched && this.search_dietary) {
      search_condition_matched = true;
      const searchlist = this.locationList.filter(item => item.oocls_dietary_options.toLowerCase().indexOf(this.search_dietary.toLowerCase()) !== -1);
      this.locationList = searchlist;
    }
    else {
      search_condition_matched = true;
      const searchlist = this.locationList.filter(item => item.oocls_company_name.toLowerCase().indexOf(this.search_resturant_name.toLowerCase()) !== -1);
      this.locationList = searchlist;
    }
    // order by location distance descending
    const searchlistbydistance = this.locationList.sort((a, b) => a.location_distance_meters < b.location_distance_meters ? -1 : a.location_distance_meters > b.location_distance_meters ? 1 : 0);
    this.locationList = searchlistbydistance;
  }

  /*
  // Method the get the store distance from user location
  getStoreDistanceFromUserLocation(userCoOrdinates) {
    const settings = this.webstorage.sessionSt_settings_locations;
    // get default values let the distance update in background
    this.getSessionValue();
    // set the distance from user location
    const input = {
      "origins": {
        "type": "MultiPoint",
        "coordinates": []
      },
      "destinations": {
        "type": "MultiPoint",
        "coordinates": []
      }
    };
    let destinationCordinates = '';
    settings.forEach(setting => {
      const latlng = setting.oocls_location_latlang.split(',');
      const latlngArray = [];
      latlngArray.push(Number(latlng[1]));
      latlngArray.push(Number(latlng[0]));
      input.destinations.coordinates.push(latlngArray);
      destinationCordinates = destinationCordinates + latlng + '|';
    });
    destinationCordinates = destinationCordinates.slice(0, -1);
    // call google api to calculate the distance from user location

    input.origins.coordinates.push(userCoOrdinates.lat + ',' + userCoOrdinates.lng);
    const userlocationCordinates = userCoOrdinates.lat + ',' + userCoOrdinates.lng;
    const locationDistance = [];
    const url = EcomNetworkUtils.ALLOW_CORS_ORIGIN + EcomNetworkUtils.G_GET_USER_LOCATION_DISTANCE + '?key=' + this.ecomservice.GetOlarConfigValue('googleapi_googlemapsapikey') + '&departure_time=now&origins=' + userlocationCordinates + '&destinations=' + destinationCordinates;
    // const url = EcomNetworkUtils.G_GET_USER_LOCATION_DISTANCE + '?key=' + olarconfig.googlemapsapikey + '&departure_time=now&origins=' + userlocationCordinates + '&destinations=' + destinationCordinates;

    if (userlocationCordinates) {
      this.ecomservice.httpGetOuterResponseHeader(url, '', true).subscribe((response: HttpResponse<any>) => {
        if (response.status === 200) {
          if (response.body.rows.length > 0) {
            let statusZeroResult = true;
            response.body.rows[0].elements.forEach(mat => {
              if (mat.status === 'OK') {
                const distance = {
                  text: mat.distance.text,
                  value: mat.distance.value
                }
                locationDistance.push(distance);
                statusZeroResult = false;
              } else {
                const distance = {
                  text: 'N/A',
                  value: 999999999999999
                }
                locationDistance.push(distance);
                if (mat.status === 'ZERO_RESULTS') {
                  if (statusZeroResult) {
                    statusZeroResult = true;
                  }
                }
              }
            });
            // update distance
            if (locationDistance.length > 0) {
              let index = 0;
              settings.forEach(setting => {
                setting.location_distance = locationDistance[index].text;
                setting.location_distance_meters = locationDistance[index].value;
                index = index + 1;
              });
              this.webstorage.sessionSt_settings_locations = settings;
              if (statusZeroResult) {
                this.webstorage.sessionSt_distance_calculated = false;
              } else {
                this.webstorage.sessionSt_distance_calculated = true;
              }
              this.getSearchedList();
            }
          }
        }
      });
    }
  }
*/
  // Method to handle the map icon click event
  onMapIconClick(locationDetails) {
    const latlng = locationDetails.oocls_location_latlang;
    this.modalRef = this.modalService.show(this.locationmap, this.config);
    this.markers = [];
    this.lat = Number(latlng.split(',')[0]);
    this.lng = Number(latlng.split(',')[1]);
    this.markers.push(
      {
        lat: latlng.split(',')[0],
        lng: latlng.split(',')[1],
        label: '',
        draggable: false,
        iconUrl: 'https://executiveedge.ie/wp-content/plugins/google-maps/assets/images/icons/azuremarker48.png',
      }
    );
    this.locationAddress = locationDetails.oocls_location_address;
    this.companyName = locationDetails.oocls_company_name;
    this.locationLatLng = locationDetails.oocls_location_latlang;
  }

  // Method to handle the map close icon click event
  onCloseMapClick() {
    this.modalRef.hide();
    //$('.modal').css({"display": "none"});
  }

  clickedMarker(label: string, index: number) {
  }

  mapClicked($event: MouseEvent) {
    // this.markers.push({
    //   lat: $event['coords'].lat,
    //   lng: $event['coords'].lng,
    //   draggable: true
    // });
  }

  markerDragEnd(m: marker, $event: MouseEvent) {
  }

  // Method to navigate to google map address
  mapsNavigate() {
    window.open("http://maps.google.co.uk/maps?q=" + this.locationLatLng, "_blank");
  }
  headerEventEmitterStores(event) {
    let address: Address;
    if (event.address && event.changed) {
      address = event.address;
      //this.webstorage.localSt_current_location = address.name + ',' + address.formatted_address;
      this.cookie.cookie_user_location = address.name + ',' + address.formatted_address;
      const userLatlng = {
        lat: address.geometry.location.lat(),
        lng: address.geometry.location.lng()
      };
      //this.webstorage.localSt_latlng = userLatlng.lat + ',' + userLatlng.lng;
      this.cookie.cookie_latlng = userLatlng.lat + ',' + userLatlng.lng;
      const header = {
        type: 'userlocation',
        data: userLatlng
      };
      const countrycode = address.address_components.find(obj => {
        return obj.types[0] === 'country'
      });
      if (countrycode) {
        //this.webstorage.localSt_user_country_code = countrycode.short_name;
        this.cookie.cookie_country_code = countrycode.short_name;
      }
      // city and pincode
      const pincode = address.address_components.find(obj => {
        return obj.types[0] === 'postal_code'
      });
      if (pincode) {
        this.cookie.cookie_pincode = pincode.long_name;
      }

      const locality = address.address_components.find(obj => {
        return obj.types[0] === 'locality'
      });
      if (locality) {
        this.cookie.cookie_usercity = locality.long_name;
      }
      this.pageIndex = 0;
      this.locationList = [];
      this.getSettingsOnScroll();
    }
  }

  onItemSelect(item, location) {
    this.webstorage.sessionSt_qr_code_scanned = undefined;
    this.webstorage.sessionSt_category_selected = undefined;
    this.webstorage.sessionSt_item_selected = undefined;
    this.webstorage.sessionSt_active_category = undefined;
    this.webstorage.sessionSt_searched_item = item;
    this.webstorage.sessionSt_store_open_for_orders = location.oocls_order_open ? 'YES' : 'NO';
    this.webstorage.sessionSt_scanned_dinein_table = false;
    this.webstorage.sessionSt_scanned_entry = false;
    this.webstorage.sessionSt_location_selected = location;
    this.webstorage.sessionSt_frompage = 'stores';
    this.webstorage.sessionSt_topage = 'items';
    this.webstorage.sessionSt_company_clicked = location.oocls_company_name.trim().replace(/\s+/g, '-').toLowerCase();
    this.router.navigate([this.webstorage.sessionSt_topage, this.webstorage.sessionSt_company_clicked]);
  }

}

// an interface for type safety.
interface marker {
  lat: number;
  lng: number;
  label?: string;
  draggable: boolean;
  iconUrl: string
}
